import { useParamsSearch } from '@anytag/shared-hooks';
import { useState } from 'react';

export const useSetHubspotDealIntoUrl = () => {
  const { state, setParamsState } = useParamsSearch<{
    state: {
      hubspotDealIds: string[];
    };
  }>();
  const [unsavedChangesDialogOpen, setUnsavedChangesDialogOpen] = useState(false);
  let approveButton: HTMLElement | null;

  return {
    setHubspotDealIntoUrl: (hubspotDealIds: string[]) => {
      setParamsState({ hubspotDealIds });
    },
    setUnsavedChangesDialogOpen: () => {
      setUnsavedChangesDialogOpen(true);
      approveButton = document.getElementById('mkp-save-button');
      if (approveButton) {
        approveButton.scrollIntoView({ behavior: 'smooth' });
        approveButton.classList.add('active-button-ring');
      }
    },
    setUnsavedChangesDialogClose: () => {
      setUnsavedChangesDialogOpen(false);
      approveButton = document.getElementById('mkp-save-button');
      if (approveButton) {
        approveButton.classList.remove('active-button-ring');
      }
    },
    hubspotDealIdsFromUrl: state?.hubspotDealIds,
    unsavedChangesDialogOpen
  };
};
